import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 16, showValue = false, count, className = "" }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="star-rating">
      <div className="flex items-center">
        {[0,1,2,3,4].map((i) => (
          <Star
            key={i}
            size={size}
            className={
              i < full
                ? "fill-[#D4A373] text-[#D4A373]"
                : i === full && half
                ? "fill-[#D4A373]/60 text-[#D4A373]"
                : "fill-transparent text-stone-300"
            }
            strokeWidth={1.5}
          />
        ))}
      </div>
      {showValue && (
        <span className="text-sm font-semibold text-stone-800">{value.toFixed(1)}</span>
      )}
      {count !== undefined && (
        <span className="text-xs text-stone-500">({count})</span>
      )}
    </div>
  );
}
